export default "__VITE_ASSET__59h83LPX__"